export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW'
export function setCurrentView(view) {
  return {
    type: SET_CURRENT_VIEW,
    payload: view,
  }
}